module.exports = __webpack_public_path__ + "img/2.597a076a.jpg";